// extracted by mini-css-extract-plugin
export default {"container":"LsSearch_container__RTSv5","input":"LsSearch_input__AJTbz"};